'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(r, e) {
    if (null == r) return {};
    var t, o, n = _object_without_properties_loose(r, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(r);
        for(o = 0; o < i.length; o++)t = i[o], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(r, t) && (n[t] = r[t]);
    }
    return n;
}
function _object_without_properties_loose(r, e) {
    if (null == r) return {};
    var t, o, n = {}, i = Object.keys(r);
    for(o = 0; o < i.length; o++)t = i[o], e.indexOf(t) >= 0 || (n[t] = r[t]);
    return n;
}
const BreadcrumbList = renderWithRef('BreadcrumbList', null, (t, o)=>{
    var { children: n } = t;
    return jsx(RenderComp, {
        root: "ul",
        forwardedRef: o,
        props: _object_without_properties(t, [
            "children"
        ]),
        children: n
    });
});

export { BreadcrumbList };
